import React from 'react'
import {MAIN_SERVER} from '../constants/constants';

const BatteryDetails = () => 
            <div className="w_bbu">
                <div className="w_details-panel">
                <div className="details-panel-desc">
                    <div className="padding-horiz-tiny">
                        Your Optical Network Terminal is installed with a separate Battery Backup Unit (BBU). When a fully charged 12-volt battery is installed in the BBU, you will have up to 8 hours of backup power for basic voice service, including calls to 911.</div>
                    <div className="padding-horiz-tiny bold">
                        Internet and TV service will not be available during a power outage even if a fully charged battery is installed.</div>
                </div>
                <div className="details-panel-img">
                    <img alt="power reserve" src={"/content/dam/verizon/support/consumer/supportservices/vcm-react/media/bbu.png"}/>
                    <div className="img-title">
                        Battery Backup Units</div>
                </div>
            </div>
        </div>
export default BatteryDetails


// WEBPACK FOOTER //
// ./src/components/BatteryDetails.js